import { ProductsPage } from "./ProductsPage";

export function OnlineShowcaseProductsPage() {
  return <ProductsPage catalogMode="online-showcase" />;
}
